// AuthGuard — redirige vers /auth/signin si pas de session.
// Source : PRD 03 §3 auth flow.
import { Navigate, useLocation } from "react-router";
import { useAuth } from "@/contexts/AuthContext";
import { PageSkeleton } from "./PageSkeleton";

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) return <PageSkeleton />;
  if (!session) {
    // Redirect vers signin en préservant l'URL d'origine pour post-auth return
    return (
      <Navigate
        to={`/auth/signin?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  return <>{children}</>;
}
